import type { ScheduledDetailedCopy } from './scheduled-page-copy-translations';

export const scheduledDetailedCopyArabicRussian = {
  ar: {
    status: {
      upcoming: 'قادم',
      running: 'قيد التشغيل',
      waitingBackground: 'في انتظار العمل في الخلفية',
      succeeded: 'نجح',
      failed: 'فشل',
      skipped: 'تم التخطي',
      needsAttention: 'يحتاج إلى مراجعة',
      unknownOutcome: 'نتيجة غير معروفة',
      canceled: 'ملغى',
      malformed: 'غير متاح',
      paused: 'متوقف مؤقتًا',
    },
    editor: {
      createTitle: 'جدول جديد',
      editTitle: 'تعديل الجدول',
      description: 'حدّد المهمة والتوقيت والسياق وصلاحية التنفيذ التلقائي.',
      stepOf: 'الخطوة {step} من 4',
      task: 'المهمة',
      timing: 'التوقيت',
      execution: 'التنفيذ',
      review: 'المراجعة',
      name: 'اسم الجدول',
      namePlaceholder: 'مثال: موجز أداء يوم الاثنين',
      instructions: 'تعليمات الوكيل',
      instructionsPlaceholder:
        'صِف النتيجة التي يجب أن ينتجها الوكيل والأماكن التي يمكنه العمل فيها.',
      sourceChat: 'المحادثة المصدر',
      scheduleThisChat: 'جدولة هذه المحادثة',
      sourceSnapshot:
        'تُحفظ لقطة خاصة عند الحفظ. لن تغيّر تعديلات المحادثة اللاحقة هذا الجدول.',
      sourceUnavailable:
        'المحادثة المصدر غير متاحة أو لم يعد لديك حق الوصول إليها.',
      sourceChatLockedNote:
        'يجب أن تحافظ الجداول التي تعيد استخدام محادثة مصدر على سياق مستمر وإمكانية رؤية خاصة.',
      recurrence: 'التكرار',
      once: 'مرة واحدة',
      hourly: 'كل ساعة',
      daily: 'يوميًا',
      weekdays: 'أيام العمل',
      selectedWeekdays: 'أيام محددة من الأسبوع',
      weekly: 'أسبوعيًا',
      monthly: 'شهريًا',
      date: 'التاريخ',
      time: 'الوقت المحلي',
      dayOfMonth: 'يوم الشهر',
      whenPlaceholder: 'YYYY-MM-DD',
      whenInvalid: 'أدخل التاريخ بالتنسيق YYYY-MM-DD.',
      end: 'الانتهاء',
      never: 'بلا نهاية',
      onDate: 'في تاريخ محدد',
      afterOccurrences: 'بعد عدد من مرات التشغيل',
      occurrences: 'مرات التشغيل',
      nextRuns: 'مرات التشغيل القادمة',
      schedulePreview: 'معاينة الجدول',
      noEndDate: 'لا يوجد تاريخ انتهاء.',
      runsUntil: 'يعمل حتى {date}.',
      totalRuns: 'إجمالي مرات التشغيل: {count}.',
      resolvingTime: 'جارٍ التحقق من هذا الوقت المحلي مع الخادم…',
      serverTimeRequired: 'يجب أن يؤكد الخادم هذا الوقت المحلي قبل الحفظ.',
      contextMode: 'سياق المحادثة',
      persistent: 'سياق مستمر',
      persistentDescription:
        'إعادة استخدام محادثة واحدة مملوكة للجدول عبر مرات التشغيل.',
      isolated: 'محادثة جديدة لكل تشغيل',
      isolatedDescription: 'بدء كل تشغيل بسياق مستقل.',
      visibility: 'إمكانية العرض',
      private: 'خاص',
      privateDescription:
        'يمكنك وحدك عرض الطلب الكامل والنص ونشاط الأدوات والنتيجة.',
      workspace: 'مساحة العمل',
      workspaceWarning:
        'تتيح المشاركة مع مساحة العمل الاطلاع على الطلب الكامل والنص ونشاط الأدوات والنتيجة.',
      creditPolicy: 'سياسة رصيد مساحة العمل',
      creditsAvailable: 'تستخدم مرات التشغيل رصيد مساحة العمل وحدودها الحالية.',
      creditsUnavailable:
        'لا يتوفر رصيد حاليًا في مساحة العمل. قد يتوقف الجدول عند وقت التشغيل.',
      fullAuthorityTitle: 'إجراءات الوكيل',
      fullAuthorityDescription:
        'يستخدم كل تشغيل صلاحياتك الحالية ويمكنه تنفيذ أي إجراء، بما في ذلك حذف الأشياء أو تغييرها، دون أن يسألك أولاً. قد يستهلك كل تشغيل أرصدة.',
      authorityAcknowledgment: 'السماح بأي إجراء من دون طلب الإذن أولاً.',
      authorityRequired:
        'اسمح بإجراءات الوكيل لإنشاء هذا الجدول. تعمل عمليات التشغيل دون إشراف، لذا لا يمكن لأحد الموافقة عليها لاحقًا.',
      recurrenceUnresolved:
        'تعذر تأكيد وقت التشغيل هذا. اختر التاريخ والوقت مرة أخرى.',
      notifications: 'إشعارات داخل التطبيق',
      notificationsDescription:
        'ستتلقى إشعارًا واحدًا بالنتائج النهائية التي تتطلب انتباهك.',
      reviewSummary: 'راجع المهمة والتكرار بدقة قبل إنشاء الجدول.',
      required: 'هذا الحقل مطلوب.',
      invalid: 'أدخل قيمة صالحة.',
      past: 'اختر وقتًا في المستقبل.',
      endBeforeStart: 'أنهِ الجدولة بعد أول تشغيل لها.',
      draftRestored: 'تمت استعادة مسودتك غير المحفوظة.',
      tooLong: 'هذه القيمة طويلة جدًا.',
      createDisabled: 'ليس لديك إذن لإنشاء جداول في مساحة العمل هذه.',
      saved: 'تم حفظ الجدول',
      unsavedTitle: 'هل تريد تجاهل التغييرات غير المحفوظة؟',
      unsavedDescription: 'ستفقد تغييرات هذا الجدول إذا أغلقته الآن.',
      discardChanges: 'تجاهل التغييرات',
    },
    detail: {
      title: 'تفاصيل الجدول',
      cadence: 'وتيرة التكرار',
      owner: 'المالك',
      timezone: 'المنطقة الزمنية',
      nextRun: 'التشغيل القادم',
      lastRun: 'آخر تشغيل',
      prompt: 'الطلب الكامل',
      sourceContext: 'سياق المصدر المحفوظ',
      executionMode: 'وضع التنفيذ',
      recentUsage: 'الاستخدام الأخير',
      credits: 'أرصدة',
      tools: 'الإجراءات',
      history: 'سجل التشغيل',
      transcript: 'المحادثة',
      resultFiles: 'ملفات النتائج',
      noResultFiles: 'لم يتم تسجيل أي ملفات نتائج لهذا التشغيل.',
      noRuns: 'لا توجد عمليات تشغيل بعد.',
      noTranscript: 'لا يتوفر نص لهذا التشغيل حتى الآن.',
      toolActivity: 'النشاط',
      toolInput: 'تفاصيل المهمة',
      toolResult: 'النتيجة',
      noToolActivity: 'لا يتوفر نشاط لهذا التشغيل.',
      loadMore: 'تحميل المزيد',
      preview: 'معاينة',
      sourceScheduled: 'مجدول',
      sourceManual: 'يدوي',
      sourceWatchdog: 'استرداد',
      roleUser: 'المستخدم',
      roleAssistant: 'المساعد',
      roleTool: 'الأداة',
      roleSystem: 'النظام',
      runNow: 'تشغيل الآن',
      pause: 'إيقاف مؤقت',
      resume: 'استئناف',
      share: 'مشاركة مع مساحة العمل',
      unshare: 'جعله خاصًا',
      cancelRun: 'إلغاء التشغيل النشط',
      archive: 'أرشفة',
      deleteSchedule: 'حذف الجدول',
      openThread: 'عرض المحادثة',
      confirmArchive: 'هل تريد أرشفة هذا الجدول؟',
      confirmArchiveDescription:
        'سيُلغى العمل المستقبلي مع الاحتفاظ بالسجل وبيانات التدقيق.',
      confirmDelete: 'هل تريد حذف هذا الجدول؟',
      confirmDeleteDescription:
        'سيؤدي هذا إلى حذف الجدول نهائيًا. ستبقى المحادثات السابقة والعمل المُنشأ في مساحة العمل.',
      confirmUnshareDescription:
        'سيفقد أعضاء مساحة العمل فورًا الوصول إلى المطالبة والنص ونشاط الأدوات والنتيجة.',
      confirmCancel: 'هل تريد إلغاء التشغيل النشط؟',
      confirmCancelDescription: 'سيتوقف التشغيل عند أول نقطة آمنة للإلغاء.',
      actionCompleted: 'تم تحديث الجدول',
      permissionDenied:
        'يمكنك عرض هذا الجدول، لكن لا يمكن تغييره إلا بواسطة المالك أو مسؤول الجداول.',
      needsAttention: 'يحتاج هذا التشغيل إلى مراجعة قبل متابعة العمل التلقائي.',
      runDetails: 'تفاصيل التشغيل',
    },
    notifications: {
      completed: 'اكتمل التشغيل المجدول',
      failed: 'فشل التشغيل المجدول',
      attention: 'يحتاج التشغيل المجدول إلى مراجعة',
      missed: 'فات موعد التشغيل المجدول لمرة واحدة',
      viewRun: 'عرض التشغيل',
      empty: 'لا توجد إشعارات تشغيل بعد.',
      unread: 'غير مقروء',
      read: 'مقروء',
      caughtUp: 'لقد اطلعت على كل شيء.',
    },
    errors: {
      generic: 'حدث خطأ ما. حاول مرة أخرى.',
      permission: 'ليس لديك إذن لتنفيذ هذا الإجراء.',
      disabled: 'الوكلاء المجدولون غير مفعّلين لمساحة العمل هذه بعد.',
      credits: 'لا يتوفر رصيد كافٍ في مساحة العمل.',
      limit: 'بلغت مساحة العمل الحد الأقصى للجداول النشطة.',
      runPending: 'هناك تشغيل قيد الانتظار أو التنفيذ لهذا الجدول بالفعل.',
      invalidTime: 'اختر وقتًا مستقبليًا صالحًا.',
      notFound: 'لم يعد هذا الجدول أو التشغيل متاحًا.',
    },
  },
  ru: {
    status: {
      upcoming: 'Предстоит',
      running: 'Выполняется',
      waitingBackground: 'Ожидание фоновой работы',
      succeeded: 'Успешно',
      failed: 'Ошибка',
      skipped: 'Пропущено',
      needsAttention: 'Требует внимания',
      unknownOutcome: 'Результат неизвестен',
      canceled: 'Отменено',
      malformed: 'Недоступно',
      paused: 'Приостановлено',
    },
    editor: {
      createTitle: 'Новое расписание',
      editTitle: 'Изменить расписание',
      description:
        'Настройте задачу, время, контекст и права для автономной работы.',
      stepOf: 'Шаг {step} из 4',
      task: 'Задача',
      timing: 'Время',
      execution: 'Выполнение',
      review: 'Проверка',
      name: 'Название расписания',
      namePlaceholder: 'Например, обзор показателей за понедельник',
      instructions: 'Инструкции агенту',
      instructionsPlaceholder:
        'Опишите ожидаемый результат и укажите, где агент может выполнять действия.',
      sourceChat: 'Исходный чат',
      scheduleThisChat: 'Запланировать этот чат',
      sourceSnapshot:
        'При сохранении создаётся закрытый снимок. Последующие изменения чата не повлияют на расписание.',
      sourceUnavailable:
        'Исходный чат недоступен или у вас больше нет к нему доступа.',
      sourceChatLockedNote:
        'Расписания, использующие исходный чат повторно, должны сохранять постоянный контекст и оставаться приватными.',
      recurrence: 'Повтор',
      once: 'Один раз',
      hourly: 'Каждый час',
      daily: 'Ежедневно',
      weekdays: 'По будням',
      selectedWeekdays: 'В выбранные дни недели',
      weekly: 'Еженедельно',
      monthly: 'Ежемесячно',
      date: 'Дата',
      time: 'Местное время',
      dayOfMonth: 'День месяца',
      whenPlaceholder: 'Завтра',
      whenInvalid: 'Введите дату, например «завтра».',
      end: 'Окончание',
      never: 'Никогда',
      onDate: 'В указанную дату',
      afterOccurrences: 'После заданного числа запусков',
      occurrences: 'Запуски',
      nextRuns: 'Следующие запуски',
      schedulePreview: 'Предпросмотр расписания',
      noEndDate: 'Без даты окончания.',
      runsUntil: 'Выполняется до {date}.',
      totalRuns: 'Всего запусков: {count}.',
      resolvingTime: 'Сервер проверяет указанное местное время…',
      serverTimeRequired:
        'Перед сохранением сервер должен подтвердить это местное время.',
      contextMode: 'Контекст чата',
      persistent: 'Постоянный контекст',
      persistentDescription:
        'Использовать один принадлежащий расписанию чат для всех запусков.',
      isolated: 'Новый чат для каждого запуска',
      isolatedDescription: 'Начинать каждый запуск с отдельным контекстом.',
      visibility: 'Видимость',
      private: 'Личное',
      privateDescription:
        'Только вы можете видеть полный запрос, историю, действия инструментов и результат.',
      workspace: 'Рабочее пространство',
      workspaceWarning:
        'При публикации для рабочего пространства становятся доступны полный запрос, история, действия инструментов и результат.',
      creditPolicy: 'Политика кредитов рабочего пространства',
      creditsAvailable:
        'Запуски используют текущий баланс кредитов и ограничения рабочего пространства.',
      creditsUnavailable:
        'Сейчас в рабочем пространстве нет доступных кредитов. При запуске расписание может быть приостановлено.',
      fullAuthorityTitle: 'Действия агента',
      fullAuthorityDescription:
        'Каждый запуск использует ваши текущие права и может выполнять любые действия, включая удаление или изменение данных, не спрашивая вас заранее. Каждый запуск может расходовать кредиты.',
      authorityAcknowledgment:
        'Разрешить любые действия без предварительного запроса.',
      authorityRequired:
        'Разрешите действия агента, чтобы создать это расписание. Запуски выполняются без присмотра, поэтому подтвердить их позже будет некому.',
      recurrenceUnresolved:
        'Не удалось подтвердить это время запуска. Выберите дату и время заново.',
      notifications: 'Уведомления в приложении',
      notificationsDescription:
        'Вы получите одно уведомление о каждом итоговом результате, требующем внимания.',
      reviewSummary:
        'Перед созданием внимательно проверьте задачу и периодичность.',
      required: 'Это поле обязательно.',
      invalid: 'Введите допустимое значение.',
      past: 'Выберите время в будущем.',
      endBeforeStart: 'Завершите расписание после первого запуска.',
      draftRestored: 'Ваш несохранённый черновик восстановлен.',
      tooLong: 'Значение слишком длинное.',
      createDisabled:
        'У вас нет разрешения создавать расписания в этом рабочем пространстве.',
      saved: 'Расписание сохранено',
      unsavedTitle: 'Отменить несохранённые изменения?',
      unsavedDescription:
        'Если закрыть окно сейчас, изменения расписания будут потеряны.',
      discardChanges: 'Отменить изменения',
    },
    detail: {
      title: 'Сведения о расписании',
      cadence: 'Периодичность',
      owner: 'Владелец',
      timezone: 'Часовой пояс',
      nextRun: 'Следующий запуск',
      lastRun: 'Последний запуск',
      prompt: 'Полный запрос',
      sourceContext: 'Сохранённый исходный контекст',
      executionMode: 'Режим выполнения',
      recentUsage: 'Недавнее использование',
      credits: 'кредиты',
      tools: 'действия',
      history: 'История запусков',
      transcript: 'Диалог',
      resultFiles: 'Файлы результатов',
      noResultFiles: 'Для этого запуска нет сохранённых файлов результата.',
      noRuns: 'Запусков пока не было.',
      noTranscript: 'Для этого запуска пока нет истории.',
      toolActivity: 'Активность',
      toolInput: 'Сведения о задаче',
      toolResult: 'Результат',
      noToolActivity: 'Для этого запуска нет активности.',
      loadMore: 'Загрузить ещё',
      preview: 'Предпросмотр',
      sourceScheduled: 'По расписанию',
      sourceManual: 'Вручную',
      sourceWatchdog: 'Восстановление',
      roleUser: 'Пользователь',
      roleAssistant: 'Помощник',
      roleTool: 'Инструмент',
      roleSystem: 'Система',
      runNow: 'Запустить сейчас',
      pause: 'Приостановить',
      resume: 'Возобновить',
      share: 'Открыть рабочему пространству',
      unshare: 'Сделать личным',
      cancelRun: 'Отменить активный запуск',
      archive: 'Архивировать',
      deleteSchedule: 'Удалить расписание',
      openThread: 'Просмотреть чат',
      confirmArchive: 'Архивировать это расписание?',
      confirmArchiveDescription:
        'Будущие запуски будут отменены, а история и аудит сохранятся.',
      confirmDelete: 'Удалить это расписание?',
      confirmDeleteDescription:
        'Расписание будет удалено без возможности восстановления. Прошлые беседы и созданные материалы останутся в рабочем пространстве.',
      confirmUnshareDescription:
        'Участники рабочего пространства сразу потеряют доступ к запросу, стенограмме, действиям инструментов и результату.',
      confirmCancel: 'Отменить активный запуск?',
      confirmCancelDescription:
        'Запуск остановится в ближайшей безопасной точке отмены.',
      actionCompleted: 'Расписание обновлено',
      permissionDenied:
        'Вы можете просматривать расписание, но изменять его может только владелец или администратор расписаний.',
      needsAttention:
        'Перед продолжением автономной работы этот запуск необходимо проверить.',
      runDetails: 'Сведения о запуске',
    },
    notifications: {
      completed: 'Запланированный запуск завершён',
      failed: 'Запланированный запуск завершился ошибкой',
      attention: 'Запланированный запуск требует внимания',
      missed: 'Однократный запуск по расписанию пропущен',
      viewRun: 'Посмотреть запуск',
      empty: 'Уведомлений о запусках пока нет.',
      unread: 'Не прочитано',
      read: 'Прочитано',
      caughtUp: 'Вы просмотрели все уведомления.',
    },
    errors: {
      generic: 'Что-то пошло не так. Повторите попытку.',
      permission: 'У вас нет разрешения на это действие.',
      disabled:
        'Агенты по расписанию пока не включены для этого рабочего пространства.',
      credits: 'В рабочем пространстве недостаточно кредитов.',
      limit: 'Достигнут предел активных расписаний для рабочего пространства.',
      runPending:
        'Для этого расписания уже есть ожидающий или выполняющийся запуск.',
      invalidTime: 'Выберите допустимое время в будущем.',
      notFound: 'Это расписание или запуск больше недоступны.',
    },
  },
} satisfies Record<'ar' | 'ru', ScheduledDetailedCopy>;
